import { useState } from "react";
import { Box, Button, Grid } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { createCommissionDispatch } from "../../store/reducers/userProfileReducer";
import Title from "../../components/ReusableComponents/title";
import CombinedPopup from "../../components/Popups/CombinedPopup";
import copyIcon from "../../assets/icons/copy-white.svg";
import CopyToClipboard from "react-copy-to-clipboard";
import toast from "react-hot-toast";

function CreateAffiliate() {
  const dispatch = useDispatch();
  const { url, referalCode } = useSelector((state) => state.user);
  const [link, setLink] = useState(false);

  const [showPopup, setShowPopup] = useState(false);
  const [popupHead, setPopupHead] = useState("");
  const [popupBody, setPopupBody] = useState("");
  const [popupType, setPopupType] = useState("");

  const handleSubmit = async () => {
    try {
      const payload = {};
      const res = await dispatch(createCommissionDispatch(payload));

      if (res.status && res.status !== 200) {
        setPopupHead("Error");
        setPopupBody(res.message || "Something went wrong. Please try again!");
        setPopupType("error");
      } else {
        setLink(true);
        setPopupHead("Woo Hoo");
        setPopupBody("Affiliate Link successfully created");
        setPopupType("success");
      }
    } catch (err) {
      setPopupHead("Error");
      setPopupBody(err.message || "Something went wrong. Please try again!");
      setPopupType("error");
    } finally {
      setShowPopup(true);
    }
  };

  const showToast = (message) => {
    toast.success(message, {
      position: "top-right",
      duration: 2000,
      className: "custom-toast-container",
      style: { background: "#333", color: "#fff" },
    });
  };

  const handleCopyToClipboard = (text) => {
    if (text) {
      showToast("Affiliate link copied.");
    }
  };

  // Extract affiliate code from URL
  const affiliateCode = url?.replace(
    "https://app.alphacapitalgroup.uk/signup/",
    ""
  );

  return (
    <Box>
      <Grid container spacing={2} style={{ textAlign: "left" }}>
        <Grid item xs={12}>
          <Title sx={{ mb: 2 }}>Create Affiliate Code</Title>
          <Box className="create_affiliate_code">
            <Box className="info_box">
              {link && (
                <Box className="input_wrapper">
                  <p className="title">Your Affiliate Link</p>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <input
                      placeholder="Your full affiliate link will appear here"
                      type="text"
                      value={link ? url : ""}
                      disabled
                      className="affiliate-code-input"
                      readOnly
                    />
                    <CopyToClipboard
                      text={url}
                      onCopy={() => handleCopyToClipboard(url)}
                      disabled={!link || !url}
                    >
                      <Button
                        className="copy_btn"
                        variant="outlined"
                        startIcon={<img src={copyIcon} alt="Copy icon" />}
                        disabled={!link || !url}
                      >
                        Copy Link
                      </Button>
                    </CopyToClipboard>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <input
                      placeholder="Your affiliate code will appear here"
                      type="text"
                      value={link ? affiliateCode : ""}
                      disabled
                      className="affiliate-code-input"
                      readOnly
                    />
                    <CopyToClipboard
                      text={affiliateCode}
                      onCopy={() => handleCopyToClipboard(affiliateCode)}
                      disabled={!link || !affiliateCode}
                    >
                      <Button
                        className="copy_btn"
                        variant="outlined"
                        startIcon={<img src={copyIcon} alt="Copy icon" />}
                        disabled={!link || !affiliateCode}
                      >
                        Copy Code
                      </Button>
                    </CopyToClipboard>
                  </Box>
                </Box>
              )}
              <Box className="btn_wrapper">
                <Button
                  className="unique-code-generate-button"
                  variant="contained"
                  onClick={handleSubmit}
                  sx={{
                    px: 4,
                    py: 1.5,
                    borderRadius: "15px",
                    textTransform: "capitalize",
                  }}
                >
                  Generate your Affiliate Code
                </Button>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>

      {showPopup && (
        <CombinedPopup
          head={popupHead}
          subhead={popupBody}
          type={popupType}
          trigger={showPopup}
          setTrigger={setShowPopup}
        />
      )}
    </Box>
  );
}

export default CreateAffiliate;
